<template>
    <div>
   
    <services-component />
    </div>
</template>

<script>
import ServicesComponent from '@/components/ServicesComponent.vue'


    export default {
        name:'ServicesView',
        components: {
                ServicesComponent,
            
    
        },
    }
</script>

